import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Typography } from 'antd'
import Button from '../../common/Button'
import { useIntl } from 'react-intl'

const DtcMappingRows = ({ mappings, category, deleteMapping }) => {
  const intl = useIntl()
  return mappings.length > 0 ? (
    <>
      <Flex className="dtc-grid-row">
        <Typography.Text className="col-title bolder">{category}:</Typography.Text>

        <Flex vertical gap={0} className="full-width">
          {mappings.map((mapping, idx) => (
            <Flex
              key={idx} 
              data-testid="dtc-mapping-row"
              data-category={category}
              align="flex-start"
              justify="space-between"
              gap={5}
              className="col-content full-width"
            >
              <Flex vertical>
                <Typography.Text className="mapping-name bolder">
                  {mapping.name}
                </Typography.Text>
                <Typography.Text className="mapping-desc">
                  {mapping.description}
                </Typography.Text>
              </Flex>

              <Button type="link" className="link-button action danger" testId="dtc-mapping-delete" onClick={() => {
                deleteMapping(mapping.id, category, mapping.name)
              }}>
                {intl.formatMessage({ id: 'forms.delete' })}
              </Button>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </>
  ) : null
}

DtcMappingRows.propTypes = {
  mappings: PropTypes.arrayOf(PropTypes.object).isRequired,
  category: PropTypes.string.isRequired,
}

export default DtcMappingRows
